import {
  MODAL_UPDATE,
  MODAL_CLOSE_ALL,
  API_ERROR_SET,
} from './types';

export default {
  /**
   * Update modal info auth modal
   *
   * @prop {String} name - name of modal
   * @prop {String|Boolean|Array|Object} data - new data for modal
   */
  [MODAL_UPDATE]: ({ commit }, { name, data = null }) => {
    commit(MODAL_UPDATE, { name, data });
  },
  /**
   * Update modal info auth modal
   *
   * @prop {String} name - name of modal
   * @prop {String|Boolean|Array|Object} data - new data for modal
   */
  [MODAL_CLOSE_ALL]: ({ commit }) => {
    commit(MODAL_CLOSE_ALL);
  },

  /**
   * Set api error
   *
   * @prop {String} detail - name of modal
   * @prop {String|Boolean|Array|Object} data - error data
   */
  [API_ERROR_SET]: ({ commit }, { data, detail }) => {
    commit(API_ERROR_SET, { data, detail });
  },
};



// WEBPACK FOOTER //
// ./src/apps/core/store/actions.js